import Preloader from "components/Common/Loader"
import RoleForm from "components/Role/form"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import {
  getByIdRole,
  updateRolePermission,
  getAllPermissionsGrouped,
} from "store/role/role-action"
import { roleAction } from "store/role/role-slice"

const EditRole = () => {
  document.title = "Edit Role"
  const { id } = useParams()
  const navigate = useNavigate()
  const { loading, error, role, groupedPermissions } = useSelector(
    state => state.role
  )
  const permissionResponse = useSelector(state => state.role.permissionChange)

  const dispatch = useDispatch()

  // call dispatch updateRolePermission to update permissoin when onChangePermission callback call
  const onChangePermission = (permission, status) => {
    dispatch(updateRolePermission(id, permission, status))
  }

  // fetch role by id and grouped permissions
  useEffect(() => {
    dispatch(getByIdRole(id))
    dispatch(getAllPermissionsGrouped())

    return () => {
      dispatch(roleAction.resetState())
    }
  }, [dispatch, id])

  if (!role) {
    return <Preloader loading={true} />
  }

  return (
    <React.Fragment>
      {role && (
        <>
          <RoleForm
            loading={loading}
            error={error}
            role={role}
            formMode={"Edit"}
            onChangePermission={onChangePermission}
            permissionResponse={permissionResponse}
            groupedPermissions={groupedPermissions}
          />
        </>
      )}
    </React.Fragment>
  )
}

export default EditRole
